import Icon from '../../../Icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from './Block';
import Item from './Item';
import { arrayToList } from '../../../../utils/functions';

const Location = ({ selectedLocations, zones = [] }) => {
    const { t } = useTranslation();
    const all = t(
        'sections.campaigns.new-campaign.wizard-briefBar.location.all'
    );
    return (
        <Block
            icon={
                <Icon
                    name="map-marker"
                    fixedWidth
                    size="lg"
                    className="m-1 text-blue-300"
                />
            }
            title={t('sections.campaigns.new-campaign.wizard-tab.location')}>
            <Item
                title={t(
                    'sections.campaigns.new-campaign.wizard-briefBar.location.countries'
                )}>
                {arrayToList(selectedLocations.selectedCountries)}
            </Item>

            <Item
                title={t(
                    'sections.campaigns.new-campaign.wizard-briefBar.location.regions'
                )}>
                {arrayToList(selectedLocations.selectedRegions)}
            </Item>

            <Item
                title={t(
                    'sections.campaigns.new-campaign.wizard-briefBar.location.cities'
                )}>
                {arrayToList(selectedLocations.selectedCities)}
            </Item>

            {zones.length > 0 && (
                <Item
                    title={t(
                        'sections.campaigns.new-campaign.wizard-briefBar.location.places'
                    )}>
                    <ul>
                        {zones.map((zone) => (
                            <li>{zone.search}</li>
                        ))}
                    </ul>
                </Item>
            )}
        </Block>
    );
};

export default Location;
